var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTriangleUp = function SvgTriangleUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    color: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.593 15.805a1 1 0 0 0 .212-1.398 53.178 53.178 0 0 0-2.457-3.062c-.662-.763-1.396-1.551-2.081-2.157a7.4 7.4 0 0 0-1.04-.787C12.912 8.211 12.477 8 12 8s-.911.21-1.228.401a7.4 7.4 0 0 0-1.039.787c-.685.606-1.42 1.394-2.081 2.156a53 53 0 0 0-2.457 3.063 1 1 0 0 0 .212 1.398A1 1 0 0 0 6 16h12a1 1 0 0 0 .593-.195"
  })));
};
export default SvgTriangleUp;